import '../layouts/tachyons/css/tachyons.css';
import '../layouts/custom.css';
import styled from 'styled-components'

const Hero = styled.h1.attrs({
  className: 'f-headline-ns f1-m f1 fw8 mb0 mt0 sans-serif c--black1',
})`
letter-spacing:-1.1px;
line-height:110%;
`; 

const Title1 = styled.h1.attrs({
    className: 'f-5-ns f1-m f2 fw7 mb0 mt0 sans-serif c--black1',
  })`
  letter-spacing:-1.1px;
  line-height:110%;
  `; 
  
  const Title2 = styled.h2.attrs({
    className: 'f1-ns fw6 mb0 mt0 sans-serif c--black1',
  })`
  letter-spacing:-0.5px;
  line-height:110%;
  `; 
  
  const Title3 = styled.h2.attrs({
    className: 'f2-ns f3 fw6 mb0 mt0 sans-serif c--black1',
  })`
  letter-spacing:-0.5px;
  line-height:110%;

  `; 
  
  const Large = styled.h2.attrs({
    className: 'f3-ns f3-m f4 fw6 mb0 mt0 sans-serif c--grey1',
  })`
  line-height:120%;
  letter-spacing:-0.28px;

  &.dark {
    color: #242C3E;
  }

  `; 
  
  const Medium = styled.p.attrs({
    className: 'f4-ns f4-m f5 fw3 mb0 mt0 c--black1 sans-serif lh-copy',
  })`
  &.alt-monospace {
    line-height:160%;
  }
  letter-spacing:0px;
  `; 
  
  const Small = styled.p.attrs({
    className: 'f5 fw3 mb0 mt0 sans-serif c--black1',
  })`
  line-height:140%;
  letter-spacing:0px;
  `; 
  
  const Tiny = styled.p.attrs({
    className: 'f6 fw3 mb0 mt0 sans-serif c--black1',
  })`
  line-height:140%;
  letter-spacing:-0.2px;
  `; 
  
  const Micro = styled.small.attrs({
    className: 'f7 ttu fw3 mb0 mt0 sans-serif',
  })`
  letter-spacing:0.2px;
  &.alt-coverage {
    letter-spacing:0px;
  }
  `; 

  const BuddyLink = styled.a.attrs({
    className: 'f6 ttu fw7 mb0 mt0 sans-serif no-underline c--brand',
  })`
  box-shadow: none;
  letter-spacing:-0.2px;
  `;  
  
  const SayHi = styled.a.attrs({
    className: 'white',
  })`

  `; 

export {Hero, Title1, Title2, Title3, Large, Medium, Small, Tiny, Micro, BuddyLink, SayHi}
